import React from 'react';
import { HStack, Text, VStack } from '@adc/parallax-component-library';
import {
  IconBannersInfo,
  IconBannersWarning,
  IconProps,
} from '@adc/parallax-icons';

type Props = {
  type?: 'info' | 'danger' | 'warning';
  iconSize?: IconProps['size'];
  headerText?: string;
  bodyText: string;
  testID?: string;
};

export default function MessageBanner({
  iconSize = 'L',
  type,
  headerText,
  bodyText,
  testID,
}: Props) {
  let backgroundColor;
  let borderColor;
  let icon;

  switch (type) {
    case 'info':
      backgroundColor = '$support.informational.surfaceSecondary';
      borderColor = '$support.informational.surface';
      icon = (
        <IconBannersInfo
          size={iconSize}
          color="$neutral.0"
          accentColor="$support.informational.default"
        />
      );
      break;
    case 'danger':
      backgroundColor = '$support.danger.surfaceSecondary';
      borderColor = '$support.danger.surface';
      icon = (
        <IconBannersWarning
          size={iconSize}
          color="$neutral.0"
          accentColor="$support.danger.default"
        />
      );
      break;
    case 'warning':
      backgroundColor = '$support.warning.surfaceSecondary';
      borderColor = '$support.warning.surface';
      icon = (
        <IconBannersWarning
          size={iconSize}
          color="$neutral.0"
          accentColor="$support.warning.default"
        />
      );
      break;
    default:
      backgroundColor = '$support.neutral.surfaceSecondary';
      borderColor = '$support.neutral.surface';
      icon = (
        <IconBannersInfo
          size={iconSize}
          color="$neutral.0"
          accentColor="$support.neutral.default"
        />
      );
      break;
  }

  return (
    <HStack
      backgroundColor={backgroundColor}
      border="$1"
      borderColor={borderColor}
      padding="$3"
      alignItems="center"
      gap={'$2'}
      testID={testID}
    >
      <VStack>{icon}</VStack>
      <VStack flex={1} alignItems="flex-start">
        {headerText ? (
          <Text type={'$h4.strong'} textAlign="left">
            {headerText}
          </Text>
        ) : null}
        <Text type={'$bodyBase.default'} textAlign="left">
          {bodyText}
        </Text>
      </VStack>
    </HStack>
  );
}
